<template>
  <div id="app">
    <el-container class="mainCont">
      <el-aside width="200px">
        <!-- Aside content -->
        <cnavs />
      </el-aside>
      <el-container>
        <el-header height="60px">
          <!-- Header content -->
          <ctoper />
        </el-header>
        <el-main height="100%">
          <!-- Main content -->
          <transition>
            <router-view></router-view>
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<style>
html,
body,
#app,
.mainCont {
  height: 100%;
}
.mainCont {
  width: 100%;
}
.el-header {
  background-color: #fff;
  display: flex;
  align-items: center;
}
.el-main {
  padding: 7px !important;
}
body {
  margin: 0;
  background-color: #f2f3f7;
}
</style>

<script>
import cnavs from "@/components/SchoolNavs";
import ctoper from "@/components/SchoolToper.vue";

export default {
  components: { cnavs, ctoper },
};
</script>
